import React from "react";
import {Button} from "primereact/button";
import {useExam} from "../../contexts/ExamContext";
import GeneralUtils from "../../utils/GeneralUtils";

const QuestionControl = ({onFinish}) => {
    const {
        exam,
        questions = [],
        currentQuestionIndex,
        setCurrentQuestionIndex,
        toggleReviewMark,
        reviewMarks = [],
        persistOpenAnswer,
    } = useExam();

    // previously sortedQuestionList derived from exam.questionList; now use questions array directly (already ordered by backend)
    const sortedQuestionList = questions || [];
    const isFirst = currentQuestionIndex === 0;
    const isLast = currentQuestionIndex >= (sortedQuestionList.length - 1);
    const currentQuestion = sortedQuestionList[currentQuestionIndex];
    const isBookmarked = currentQuestion?.id ? (reviewMarks?.[currentQuestion.id] || false) : false;

    const handlePrev = async () => {
        if (currentQuestion?.id) { try { await persistOpenAnswer?.(currentQuestion.id); } catch {} }
        setCurrentQuestionIndex((i) => Math.max(i - 1, 0));
    };
    const handleNextOrFinish = async () => {
        if (currentQuestion?.id) { try { await persistOpenAnswer?.(currentQuestion.id); } catch {} }
        if (isLast) {
            onFinish && onFinish();
        } else {
            setCurrentQuestionIndex((i) => Math.min(i + 1, sortedQuestionList.length - 1));
        }
    };

    return (
        <>


            {/* Geri: left middle */}
            {!isFirst &&
                <Button
                icon="pi pi-arrow-left"
                rounded
                outlined
                onClick={handlePrev}
                // disabled={isFirst}
                tooltip="Önceki Soru"
                tooltipOptions={{ position: 'bottom' }}
                style={{
                    position: "absolute",
                    left: "-3.5rem",
                    top: "50%",
                    transform: "translateY(-50%)",
                }}
            />}


            {/* İşaretle: left, aligned to the card's start (top-left edge) */}
            <Button
                icon={isBookmarked ? "pi pi-bookmark-fill" : "pi pi-bookmark"}
                severity={isBookmarked ? "warning" : ""}
                rounded
                outlined
                tooltip={isBookmarked ? "İşareti Kaldır" : "İşaretle"}
                tooltipOptions={{ position: 'bottom' }}
                onClick={() => currentQuestion && toggleReviewMark?.(currentQuestion.id)}
                style={{
                    position: "absolute",
                    right: "-3.5rem",
                    top: "7rem",
                }}
            />

            {/* İleri / Bitir: right middle */}
            {!isLast && <Button
                // label={isLast ? "Bitir" : "Sonraki"}
                icon={isLast ? "pi pi-check" : "pi pi-arrow-right"}
                rounded
                outlined
                iconPos="right"
                severity={isLast ? "danger" : undefined}
                onClick={handleNextOrFinish}
                tooltip="Sonraki Soru"
                tooltipOptions={{ position: 'bottom' }}
                style={{
                    position: "absolute",
                    right: "-3.5rem",
                    top: "50%",
                    transform: "translateY(-50%)",
                }}
            />}
        </>
    );
};
export default QuestionControl;